/*Update Or Create Array By _id*/
import _ from "lodash";
Array.prototype.updateById = function(obj) {
    if (!obj._id) throw new Error("Object Id not FOUND!");
    let foundIndex = this.findIndex((p) => {
        if (p._id === obj._id) return true;
        else return false;
    });
    if (foundIndex != -1) {
        this[foundIndex] = obj;
        this.__ob__.dep.notify();
    } else {
        this.push(obj);
    }
}

